import instanceQuery from 'graphql/queries/salesLedger/SalesVatOnlyPostingPreviewQuery.graphql';
import fragment from 'graphql/fragments/nominal/NominalPostingPreviewFragment.graphql';

const SalesVatOnlyPostingPreview = {
  type: 'PostingResponse',
  formTitle: 'Nominal Posting Preview',
  instance: instanceQuery,
  fragment,
};

export default SalesVatOnlyPostingPreview;
